import Cookies from 'js-cookie';

export function getB2bCopyTestVariant(): string {
	const variant = Cookies.get('b2bTestVariant');
	return variant || '';
}

export function setSelfserveLeadRerouteTestVariant(): void {
	const rerouteCookieName = 'b2b_selfserve_lead_reroute_variation';
	const rerouteCookieValue = 'reroute';

	Cookies.set(rerouteCookieName, rerouteCookieValue, { domain: '.calm.com' });
}
